// import {
// 	XMarkIcon,
// } from '@heroicons/react/24/outline'

// import {
// 	Squares2X2Icon,
// } from '@heroicons/react/24/outline'


import { string } from 'yup';

const obj =  {
	field:[
		{ 
			title: "helloword", 
			attr: "language",  
			value: "", 
			placeholder: "JavaScript...", 
			label: "Which language are you using, will enable markup highlights",
			type: "text",
			maxLength: 40,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("helloword is Required "),

			id:1,
			// options: [{ title: "2nd Grader", value: "2nd Grader", desc: "Explain this like I'm 5 years old", Icon: AnnotationIcon },],
			// max: 100,
			min: 3,
			required: true,
			error: "",
			example: `JavaScript`,
		},
		{ 
			title: "Code Editor", 
			attr: "content",  
			value: "", 
			id:2,
			placeholder: "function Name(attr){...", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Code Editor is Required"),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
	],
	   example:[
		{ 
			title: "Language", 
			attr: "language",  
			value: "helloword one", 
			placeholder: "JavaScript...", 
			label: "Which language are you using, will enable markup highlights",
			type: "text",
			maxLength: 40,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Language is  Required"),

			id:1,
			// options: [{ title: "2nd Grader", value: "2nd Grader", desc: "Explain this like I'm 5 years old", Icon: AnnotationIcon },],
			// max: 100,
			min: 3,
			required: true,
			error: "",
			example: `JavaScript`,
		},
		{ 
			title: "Code Editor", 
			attr: "content",  
			value: "helloword two", 
			id:2,
			placeholder: "function Name(attr){...", 
			label: "Place some code above to understand how it works",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Code Editor is Required"),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
	],
	editor:{
		output:"Hello World"
	}
	}
	
	
	export default obj
	
	